import { render, staticRenderFns } from "./Spends.vue?vue&type=template&id=17ba36f2&"
import script from "./Spends.vue?vue&type=script&lang=js&"
export * from "./Spends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports